<div fxLayout="column" fxFlex="100" fxLayoutGap="20px">
  <div class="container" fxLayout="column" fxFlex="100" fxLayoutGap="20px">
    <h1 class="header">{{ 'HolidayList.HolidayList' | translate }}</h1>
    <div class="content-card">
      <mat-tab-group (selectedTabChange)="onTabChanged($event)" mat-stretch-tabs="false">
        @for (link of navigation; track link) {
          <mat-tab [label]="'HolidayList.' + link.listType | translate"> </mat-tab>
        }
      </mat-tab-group>
    </div>

    <router-outlet></router-outlet>
  </div>
</div>
